export let DataType = /*#__PURE__*/function (DataType) {
  DataType["UNKNOWN_DataType"] = "UNKNOWN_DataType";
  /** A simple text value */
  DataType["text"] = "text";
  /** A list of predefined textual values to choose from */
  DataType["textEnum"] = "textEnum";
  /** Any number */
  DataType["number"] = "number";
  /** true / false value */
  DataType["booleanValue"] = "booleanValue";
  /** An object containing the selected A11Y fields chosen */
  DataType["a11y"] = "a11y";
  /** A Wix Link object type */
  DataType["link"] = "link";
  /** A Wix Image object type */
  DataType["image"] = "image";
  /** A Wix Video object type */
  DataType["video"] = "video";
  /** A Wix Sanitized Vector Art object */
  DataType["vectorArt"] = "vectorArt";
  /** A Wix Audio object */
  DataType["audio"] = "audio";
  /** A [JSON Schema definition](https://json-schema.org/specification) the developer understands in his code (useful for complex props). Some limitation may apply. */
  DataType["schema"] = "schema";
  /** Local date output ISO-8601 extended local date format (YYYY-MM-DD) */
  DataType["localDate"] = "localDate";
  /** Local time output ISO-8601 extended local time format (hh:mm[:ss][.sss]) */
  DataType["localTime"] = "localTime";
  /** Local Date Time output  ISO-8601 extended local date-time format (YYYY-MM-DDThh:mm[:ss][.sss]) */
  DataType["localDateTime"] = "localDateTime";
  /** a URL with scheme http or https */
  DataType["webUrl"] = "webUrl";
  /** standard email address according to [RFC 5321, section 4.1.2](https://datatracker.ietf.org/doc/html/rfc5321#section-4.1.2) */
  DataType["email"] = "email";
  /** a validation format designed to match phone numbers with a variety of common characters, including digits (0-9), spaces, parentheses, plus sign, hyphens, and periods */
  DataType["phone"] = "phone";
  /** hostname according to IANA */
  DataType["hostname"] = "hostname";
  /** A valid `regex` pattern supplied by the User */
  DataType["regex"] = "regex";
  /** A unique identifier */
  DataType["guid"] = "guid";
  /** a HTML text with css inline styling */
  DataType["richText"] = "richText";
  /** A container place in the component that will be passed in as {children} or a function prop, depending on the case */
  DataType["container"] = "container";
  /** An array type of data */
  DataType["arrayItems"] = "arrayItems";
  /** selected `direction` for the component according to (HTML `dir` attribute)[https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/dir] */
  DataType["direction"] = "direction";
  return DataType;
}({});
export let StyleType = /*#__PURE__*/function (StyleType) {
  StyleType["UNKNOWN_CssPropertyType"] = "UNKNOWN_CssPropertyType";
  StyleType["booleanValue"] = "booleanValue";
  /** background properties */
  StyleType["background"] = "background";
  StyleType["backgroundSize"] = "backgroundSize";
  StyleType["backgroundColor"] = "backgroundColor";
  StyleType["backgroundImage"] = "backgroundImage";
  StyleType["backgroundClip"] = "backgroundClip";
  StyleType["backgroundOrigin"] = "backgroundOrigin";
  StyleType["backgroundPosition"] = "backgroundPosition";
  StyleType["backgroundRepeat"] = "backgroundRepeat";
  StyleType["backgroundAttachment"] = "backgroundAttachment";
  /** margin properties */
  StyleType["margin"] = "margin";
  StyleType["marginTop"] = "marginTop";
  StyleType["marginRight"] = "marginRight";
  StyleType["marginBottom"] = "marginBottom";
  StyleType["marginLeft"] = "marginLeft";
  StyleType["marginInlineStart"] = "marginInlineStart";
  StyleType["marginInlineEnd"] = "marginInlineEnd";
  /** padding properties */
  StyleType["padding"] = "padding";
  StyleType["paddingTop"] = "paddingTop";
  StyleType["paddingRight"] = "paddingRight";
  StyleType["paddingBottom"] = "paddingBottom";
  StyleType["paddingLeft"] = "paddingLeft";
  StyleType["paddingInlineStart"] = "paddingInlineStart";
  StyleType["paddingInlineEnd"] = "paddingInlineEnd";
  /** border properties */
  StyleType["border"] = "border";
  StyleType["borderWidth"] = "borderWidth";
  StyleType["borderStyle"] = "borderStyle";
  StyleType["borderColor"] = "borderColor";
  StyleType["borderTop"] = "borderTop";
  StyleType["borderTopColor"] = "borderTopColor";
  StyleType["borderTopWidth"] = "borderTopWidth";
  StyleType["borderTopStyle"] = "borderTopStyle";
  StyleType["borderRight"] = "borderRight";
  StyleType["borderRightColor"] = "borderRightColor";
  StyleType["borderRightWidth"] = "borderRightWidth";
  StyleType["borderRightStyle"] = "borderRightStyle";
  StyleType["borderBottom"] = "borderBottom";
  StyleType["borderBottomColor"] = "borderBottomColor";
  StyleType["borderBottomWidth"] = "borderBottomWidth";
  StyleType["borderBottomStyle"] = "borderBottomStyle";
  StyleType["borderLeft"] = "borderLeft";
  StyleType["borderLeftColor"] = "borderLeftColor";
  StyleType["borderLeftWidth"] = "borderLeftWidth";
  StyleType["borderLeftStyle"] = "borderLeftStyle";
  StyleType["borderInlineStart"] = "borderInlineStart";
  StyleType["borderInlineStartColor"] = "borderInlineStartColor";
  StyleType["borderInlineStartWidth"] = "borderInlineStartWidth";
  StyleType["borderInlineStartStyle"] = "borderInlineStartStyle";
  StyleType["borderInlineEnd"] = "borderInlineEnd";
  StyleType["borderInlineEndColor"] = "borderInlineEndColor";
  StyleType["borderInlineEndWidth"] = "borderInlineEndWidth";
  StyleType["borderInlineEndStyle"] = "borderInlineEndStyle";
  StyleType["borderRadius"] = "borderRadius";
  StyleType["borderTopLeftRadius"] = "borderTopLeftRadius";
  StyleType["borderTopRightRadius"] = "borderTopRightRadius";
  StyleType["borderBottomRightRadius"] = "borderBottomRightRadius";
  StyleType["borderBottomLeftRadius"] = "borderBottomLeftRadius";
  StyleType["borderStartStartRadius"] = "borderStartStartRadius";
  StyleType["borderStartEndRadius"] = "borderStartEndRadius";
  StyleType["borderEndStartRadius"] = "borderEndStartRadius";
  StyleType["borderEndEndRadius"] = "borderEndEndRadius";
  /** text properties */
  StyleType["font"] = "font";
  StyleType["fontFamily"] = "fontFamily";
  StyleType["fontSize"] = "fontSize";
  StyleType["fontStretch"] = "fontStretch";
  StyleType["fontStyle"] = "fontStyle";
  StyleType["fontVariant"] = "fontVariant";
  StyleType["fontWeight"] = "fontWeight";
  StyleType["lineHeight"] = "lineHeight";
  StyleType["color"] = "color";
  StyleType["letterSpacing"] = "letterSpacing";
  StyleType["textAlign"] = "textAlign";
  StyleType["textTransform"] = "textTransform";
  StyleType["textShadow"] = "textShadow";
  StyleType["textDecoration"] = "textDecoration";
  StyleType["textDecorationColor"] = "textDecorationColor";
  StyleType["textDecorationLine"] = "textDecorationLine";
  StyleType["textDecorationStyle"] = "textDecorationStyle";
  StyleType["textDecorationThickness"] = "textDecorationThickness";
  /** general box properties */
  StyleType["boxShadow"] = "boxShadow";
  StyleType["opacity"] = "opacity";
  StyleType["overflow"] = "overflow";
  /** layout properties */
  StyleType["alignSelf"] = "alignSelf";
  StyleType["justifyContent"] = "justifyContent";
  StyleType["alignItems"] = "alignItems";
  StyleType["flexDirection"] = "flexDirection";
  StyleType["gap"] = "gap";
  StyleType["height"] = "height";
  StyleType["width"] = "width";
  /** filters */
  StyleType["filter"] = "filter";
  StyleType["backdropFilter"] = "backdropFilter";
  /** media sizing & alignment */
  StyleType["objectFit"] = "objectFit";
  StyleType["objectPosition"] = "objectPosition";
  /** blending & compositing */
  StyleType["mixBlendMode"] = "mixBlendMode";
  StyleType["isolation"] = "isolation";
  return StyleType;
}({});
//# sourceMappingURL=variants.js.map